

import React, { useEffect, useRef, useState } from 'react'
import { Col, Container, Form, Row } from 'react-bootstrap'
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import { useSelector } from 'react-redux';
import ExportBox from "../components/ExportBox/ExportBox"
import Table from "../components/Table/Table"
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import exportImg from "../assets/Group 923.svg"
import { toast } from 'react-toastify';
import Paginations from './Paginations';

function Permissions() {
  const userinfo = useSelector((state) => state);
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const [searchText, setSearchText] = useState("");

  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationsItems, setPaginationsItems] = useState(null)

  const [items, setItems] = useState([])
  const handleExportClick = () => {
    fileInputRef.current.click(); // Programmatically trigger file input
  };
  const filteredItems = items.filter((item) => {
    const search = searchText.toLowerCase();

    const name = item?.name?.toLowerCase() || "";
    const email = item?.email?.toLowerCase() || "";
    const phone = item?.phone?.toLowerCase() || "";

    // permissions (roles)
    const roles = item?.roles
      ?.map((r) =>
        r?.id == 26 ? item?.job_title : r?.name
      )
      .join(" ")
      .toLowerCase() || "";

    return (
      name.includes(search) ||
      email.includes(search) ||
      phone.includes(search) ||
      roles.includes(search)
    );
  });
  const getAllApis = async () => {


    await axios
      .get(
        `https://nanosoft.space/taarteb/public/api/admin/employees?paginated=10&page=${currentPage}`,
        {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
          }
        })
      .then(async (res) => {
        console.log(res.data.data.meta.last_page);
        setPaginationsItems(res.data.data.meta);

        const nameMap = {
          "Financial Director": currentLocal.home.Financialofficer,
          "Sales Employee": currentLocal.home.salesemployee,
          "Purchasing Employee": currentLocal.home.Purchasingemployee,
          "Salaries Employee": currentLocal.home.Salariesemployee,
          "Maintenance Employee": currentLocal.home.Maintenanceemployee,
          "Other": currentLocal.home.Other,
            "Teacher": currentLocal.home.teacher,

        };
        const translatedEmployees = res.data.data.data.map((emp) => ({
          ...emp,
          role: nameMap[emp.role] || emp.role, // translate main role
          roles: emp.roles.map((r) => ({
            ...r,
            name: nameMap[r.name] || r.name, // translate nested role
          })),
        }));
        setItems(translatedEmployees)

      })
      .catch((error) => {


      });






  }
  useEffect(() => {

    getAllApis()

  }, [currentPage])

  const headerIterm = [
    currentLocal.home.ID,
    currentLocal.home.namePlaceholder,
    currentLocal.home.emailPlaceholder,
    currentLocal.home.phone,
    currentLocal.home.permissions,
    "",

  ]

  const body = <tbody>
    {filteredItems?.map((item, index) => {
      console.log(item?.is_active);

      return (
        <tr key={index}>
          <td>
            {item?.id}
          </td>
          <td>
            {item?.name}
          </td>
          <td>
            {item?.email}
          </td>
          <td>
            {item?.phone}
          </td>
          <td>
            {item?.roles.length != 0 ? item?.roles.map((itemx) => {
              return (

                <span>
                  {itemx?.id == 26 ? item?.job_title : itemx?.name}<br />
                </span>
              )
            }) :

              <>
                {item?.role}

              </>
            }
          </td>
          <td>
            <Form.Check
              type="switch"
              id="custom-switch"
              label="Check this switch"
              checked={item?.is_active}
              onChange={async () => {
                console.log("trtrtert", item?.id);
                try {
                  const response = await axios.post(`https://nanosoft.space/taarteb/public/api/admin/user/${item?.id}/toggle-activate`, { user_id: item?.id }, {
                    headers: {
                      Authorization: `Bearer ${userinfo.auth.userArray.access_token}`

                    },
                  });
                  getAllApis()
                  toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });
                } catch (error) {
                  console.log(error.response.data?.message);

                  console.log(Object.values(error.response.data.errors)[0][0]);

                  toast.error(error.response.data.errors ? Object.values(error.response.data.errors)[0][0] : error.response.data?.message, { position: "bottom-right", autoClose: 3000 });

                }

              }}
            />

          </td>
          <td>
            <button
              className='bg-transparent mx-2 border-info p-1 rounded'
              onClick={() => navigate(`/dashboard/edite-permission/${item?.id}`)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="rgba(13,202,240)" className="bi bi-pencil-square" viewBox="0 0 16 16">
                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
              </svg>
            </button>
          </td>





        </tr>
      )
    })}

  </tbody>

  return (
    <div className="px-0 my-3 w-100 dashboard_content">
      <Container>
        <div className="d-flex flex-column w-100">

          <AuthNavbar />
          <div className="mt-5 mx-3">
            <Container fluid>
              <Row>
                <Col md={4}>
                  <HomeTitle title={currentLocal.home.permissions} />

                </Col>
                <Col md={9}>
                  <div className=''>
                    <input
                      className='px-3 py-1 border- rounded'
                      placeholder={currentLocal.home.search}
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />

                  </div>

                </Col>
                <Col md={3}>
                  <div className='d-flex justify-content-end'>
                    <div className='d-flex justify-content-end'>
                      <div className="export_btn mx-2" onClick={handleExportClick}>
                        <img src={exportImg} alt="" />
                        <span className="mx-1">{currentLocal.home.export}</span>
                      </div>
                      {/* عنصر الـ input المخفي */}
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={async (e) => {
                          const formData = new FormData();
                          formData.append("file", e.target.files[0]);
                          try {
                            const response = await axios.post(`https://nanosoft.space/taarteb/public/api/admin/employees/import`, formData, {
                              headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: `Bearer ${userinfo.auth.userArray.access_token}`

                              },
                            });
                            toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });
                          } catch (error) {
                            console.log(error.response.data?.message);

                            console.log(Object.values(error.response.data.errors)[0][0]);

                            toast.error(error.response.data.errors ? Object.values(error.response.data.errors)[0][0] : error.response.data?.message, { position: "bottom-right", autoClose: 3000 });

                          }
                        }}
                      />
                    </div>

                  </div>
                </Col>

              </Row>


            </Container>

            <ExportBox
              title={""}
              paragrapg={' '}
              addingBtn={currentLocal.home.Addpermissions}
              exportState={false}
            />
            <Table
              data={items}
              headerIterm={headerIterm}
              actions={["edit"]}
              body={body}
            // onDataChanged={getAllApis}
            />
            <Paginations
              total={paginationsItems?.last_page}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />

          </div>

        </div>
      </Container>
    </div>)
}

export default Permissions